import Ajax from "../utils/ajax";

export default {
  namespaced: true,
  state: {
    requestListVacants: {
      skip: 1,
      criterio: "",
      cantidad: 10,
    },
    responseListVacants: {
      vacantes: [],
      cantidadVacante: 0,
    },
  },

  mutations: {
    SET_SKIP(state, skip) {
      state.requestListVacants.skip = skip;
    },
    SET_CRITERIO(state, criterio) {
      state.requestListVacants.criterio = criterio;
    },
    SET_RESPONSE_VACANTS(state, payload) {
      state.responseListVacants.vacantes = payload.vacants;
      state.responseListVacants.cantidadVacante = payload.cantidad;
    },
  },

  actions: {
    async getListVacantAvailable({ commit }, { data }) {
      try {
        const resp = await Ajax.get("/api/v1/Vacant", data);
        return Promise.resolve(resp.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async createVacant({ commit }, { data }) {
      try {
        const resp = await Ajax.post("/api/v1/Vacant", data);
        return Promise.resolve(resp.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getVacants({ commit }, { data }) {
      const resp = await Ajax.get("/api/v1/Vacant/list", { params: data });
      commit("SET_RESPONSE_VACANTS", resp.data);
    },

    async changeStatus({ commit }, { id }) {
      try {
        const resp = await Ajax.put("/api/v1/Vacant/changeStatus", {id: id});
        return Promise.resolve(resp.data);
      } catch (e) {
        return Promise.reject(e.response.data);
      }
    },
  },
};
